import {
    GET_LifestyleClassSession,
    RESET_LifestyleClassSession,
  } from "../actionTypes";

const lifestyleClassSessionReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_LifestyleClassSession:
      return action.payload;

    case RESET_LifestyleClassSession:
      return null;

    default:
      return state;
  }
};

export default lifestyleClassSessionReducer;
